import * as React from 'react';
import { ArticleParagraph1 } from '@cian/ui-kit';
import { IFeature } from '../../../../types/project';
import * as styles from './Feature.css';

type IFeatureProps = IFeature;

export const Feature: React.FC<IFeatureProps> = ({ title, value }) => {
  return (
    <div className={styles['feature']}>
      <ArticleParagraph1 color="text-secondary-default">{title}</ArticleParagraph1>
      <div className={styles['value']}>
        <ArticleParagraph1>{value}</ArticleParagraph1>
      </div>
    </div>
  );
};
